import * as Event from './../_function/event.js';

// =============================================================================
// chartist.custom.js

var resizeCharts = [];

function addResizeChart( newResizeChart ) {
  resizeCharts[ resizeCharts.length ] = newResizeChart;
}

document.addEventListener( "addResizeCharts", function( event ) {
  var newResizeCharts = event.detail.newResizeCharts;
  var newResizeChartLength = 1;
  if ( newResizeCharts instanceof Array ) newResizeChartLength = newResizeCharts.length;

  for ( var i = 0; i < newResizeChartLength; i++ ) {
    var newResizeChart = newResizeChartLength == 1 ? newResizeCharts : newResizeCharts[ i ];
    resizeCharts[ resizeCharts.length ] = newResizeCharts[ i ];
  }
} );

// document.dispatchEvent( new CustomEvent( "addResizeCharts", { detail: { newResizeCharts: chartVariable } } ) );

var resizeTimeout = [];

Event.addEvent( 'resize', window, function(event) {
  if ( !resizeCharts.length ) return;
  for ( var i = 0; i < 100; i++ ) {
    if ( resizeTimeout[ i ] !== 'undefined' ) clearTimeout( resizeTimeout[ i ] );
    resizeTimeout[ i ] = setTimeout( function() {
      for (var i = 0; i < resizeCharts.length; i++) {
        resizeCharts[i].update();
      }
    }, i * 10 );
  }
} );
